import { FC, useEffect, useState } from 'react';
import { Button, Col, Collapse, Divider, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import Page from '../../Components/Page/Page';
import BookyBox from '../../Components/Layout/BookyBox';
import { TextService } from '../../Services/TextService';
import { FilePdfOutlined } from '@ant-design/icons';
import { AuthProvider } from '../../Providers/authProvider';
import { AuthenticatedUser } from '../../Types/AuthenticatedUser';

const Contact = () => {
  const { Panel } = Collapse;
  const [user, setUser] = useState({} as AuthenticatedUser | null);

  useEffect(() => {
    AuthProvider().GetLoggedInUser().then(user => {
      setUser(user);
    });

  }, []);

  const GetText = TextService.GetText;
  return <Page pageTitle={GetText("PageTitle_Contact")}>
    <BookyBox>
      <Title>{GetText("Contact_Title")}</Title>

      <b>Kontakt</b><br />
      <p dangerouslySetInnerHTML={{ __html: GetText("Contact_ReachOut") }}></p>

      <b>Support</b><br />
      <p dangerouslySetInnerHTML={{ __html: GetText("Contact_ReachOut2") }}></p>

    </BookyBox>


    <BookyBox>
      <Title>{GetText("Contact_Document_Title")}</Title>
      <a target="_blank" href={require('./Documents/Startup_Guide_OneFront360.pdf')}><FilePdfOutlined style={{ color: "red" }} /> Startup Guide</a><br />
      {user != null && user.hasPaidSubscription ? <>
        <a target="_blank" href={require('./Documents/User_Guide_OneFront360.pdf')}><FilePdfOutlined style={{ color: "red" }} /> User Guide</a><br />
        <a target="_blank" href={require('./Documents/Administratörs_Guide_OneFront360.pdf')}><FilePdfOutlined style={{ color: "red" }} /> Administrator Guide</a><br />
        <a target="_blank" href={require('./Documents/Prislista_föreningar.pdf')}><FilePdfOutlined style={{ color: "red" }} /> Prislista föreningar</a><br />
        <a target="_blank" href={require('./Documents/Guide_GDPR_föreningar.pdf')}><FilePdfOutlined style={{ color: "red" }} /> Guide GDPR föreningar</a><br />
      </>
        : ""}
    </BookyBox>

    <BookyBox>
      <Title>{GetText("Contact_References")}</Title>
      <Paragraph>{GetText("Contact_References_Description")}</Paragraph>
    </BookyBox>
    <BookyBox>
      <Title>FAQ</Title>

      <Collapse accordion>
        <Panel header={"Kan jag använda min egen domän?"} key="2">
          <p>Det går utmärkt att koppla din egen domän till OneFront 360, då kommer mailen att signeras och dina medlemmar kommer få utskicken från er e-postadress.</p>
        </Panel>
        <Panel header={"Kan jag automatisera mina medlemsbetalningar?"} key="3">
          <p>OneFront 360 erbjuder både integration med Fortnox och med PingPayments för att automatisera medlemsinbetalningar. Det går också att hantera betalningar manuellt om så önskas.</p>
        </Panel>
        <Panel header={"Går det att integrera OneFront 360 till min egen webbsida?"} key="4">
          <p>Det går att skapa upp både nyregistreringsformulär och inloggning för att ändra medlemsuppgifter och koppla ihop med er egen webbsida.</p>
        </Panel>
        <Panel header={"Kan jag skräddarsy systemet utefter den data och behov min förening har?"} key="5">
          <p>I våra uttökade abonnemang finns det möjlighet att skärddarsy systemet. Det går att anpassa medlemsstrukturen och den data som samlas in genom att skapa egna fält, formulär och egna datatabeller efter behov.</p>
        </Panel>
      </Collapse>
    </BookyBox>
  </Page >
};

export default Contact;